module.exports = __webpack_public_path__ + "img/camera.b876c0e4.png";